
let credentials = {
  API_URL: "http://localhost:8263/api",
  API_URL_INQUIRY: "http://localhost:8024/api",
};


if(process.env.REACT_APP_API_ENDPOINT==="development"){
  credentials = {
    API_URL: "http://localhost:8263/api",
    API_URL_INQUIRY: "http://localhost:8024/api"
  }
}

if(process.env.REACT_APP_API_ENDPOINT==="prod"){
  credentials = {
    API_URL: "https://idailyacademy.com/api",
    API_URL_INQUIRY: "https://comfycraft.co.uk/api"
  }
}

export default credentials;